// Quem é administrador do FLOWAES.
// IMPORTANTE: manter igual em server/security.ts e firestore.rules.
// Esta checagem no navegador só controla o que aparece na tela; a segurança
// real é feita pelas regras do Firestore e pelo servidor (token do Firebase).

// Conta mestre (já existente no Firebase)
export const PRIMARY_ADMIN_EMAIL = 'marketing.inteligente2026@gmail.com';

// Admins adicionais: exigem e-mail VERIFICADO, para que ninguém consiga
// criar uma conta com esse endereço e virar admin.
export const VERIFIED_ADMIN_EMAILS = ['contact@flowaes.com'];

type MinimalUser = {
  email?: string | null;
  emailVerified?: boolean;
  providerData?: Array<{ email?: string | null } | null>;
} | null | undefined;

// E-mail do usuário, com fallback para o provedor (ex.: login Google)
export function getUserEmail(user: MinimalUser): string {
  const email = user?.email || user?.providerData?.find(p => p?.email)?.email || '';
  return email.trim().toLowerCase();
}

export function isAdminUser(user: MinimalUser): boolean {
  const email = getUserEmail(user);
  if (!email) return false;
  if (email === PRIMARY_ADMIN_EMAIL) return true;
  return VERIFIED_ADMIN_EMAILS.includes(email) && user?.emailVerified === true;
}

// Apenas para rótulos em listas (ex.: marcar [ADM] na lista de usuários)
export function isAdminEmailLabel(email?: string | null): boolean {
  const e = (email || '').trim().toLowerCase();
  return e === PRIMARY_ADMIN_EMAIL || VERIFIED_ADMIN_EMAILS.includes(e);
}
